import React, { Component } from 'react';
import { Drawer, Radio, Select, Spin, Tag } from "antd";
import { availabilityType, jobExperienceType, postedOnType, ucFirst } from "../../src/utils/helpers";
import Router from 'next/router'
import StickyBox from "react-sticky-box";

import { Input } from 'antd';
import {
    getAllJobs,
    jobFilterInputChange,
    applyModalOpen,
    generateStateUpdate,
    getCategory,
} from "../../src/store/actions";
import { connect } from "react-redux";
import { GetStarted, JobList, SelectCategory } from "../../src/components/common";
import { APP_GENERAL_STATE } from "../../src/store/ActionTypes";
import SearchCategoryAlgo from "../../src/components/common/SearchCategoryAlgo";
import { InstantSearch } from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch('2C08NZNUBI', '0f90489d1a0c08ba029cfad9d2367e2d');

const { Search } = Input;
const Option = Select.Option;

class Vacancies extends Component {
    static async getInitialProps(ctx) {
        try {
            ctx.store.dispatch(jobFilterInputChange({ props: 'sub_category', value: '', searchNow: false }));
            const filter = ctx.store.getState().job.filter;
            let category = null;
            if(ctx.query.slug && ctx.query.slug.length>0) {
                filter.sub_category = parseInt(ctx.query.slug[0].split('-').pop());
            
                category = await ctx.store.dispatch(getCategory({
                    id: filter.sub_category
                }));
                if (category && category.data) {
                    category = category.data.data;
                }
            }
            
            await ctx.store.dispatch(getAllJobs({ ...filter, limit: 100, job_type: 'recent' }, ctx));

            return {
                title: 'Find Jobs in Nepal- Vacancy in Nepal | Rojgari Sanjal',
                showFooter: true,
                meta_desc: 'Rojgari Sanjal is a Best job portal in Nepal. we offer all kind of jobs in Nepal,career opportunities, Part time, Full time, Freelancer jobs  in Nepal.',
                keywords: 'search jobs in Nepal, job in Nepal, rojgarisanjal.com, rojgari sanjal, job vacancies in Nepal, vacancy  in Nepal, Online jobs in Nepal, It jobs in Nepal, job vacancy in Nepal, job site in Nepal, recent job vacancies in Nepal, job opportunities in Nepal, government jobs in Nepal,  recent job vacancies in Kathmandu, job vacancies in Nepal Kathmandu, free job sites in Nepal, find jobs in Nepal, find a job in Nepal, accounting jobs in Nepal, freelancer vacancy in Nepal, job search in Nepal, how to find  jobs in Nepal, part time jobs in Nepal, find jobs in Nepal, NGO jobs in Nepal, marketing jobs in Nepal, jagir in Nepal, rojgari in Nepal',
                filterCategory: category
            }
        } catch (error) {
            console.log(error)
            return {}
        }

    }

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.myRefJobList = React.createRef();
        this.lastScrollTop = 0;
    }

    state = {
        search: '',
        address: ''
    };

    getCategoryByType(type = 'functional') {
        type = type === 'functional' ? 1 : 0;
        const { category } = this.props;

        return category.data.filter((item) => {
            return item.type === type;
        });
    }

    whichCategory(catId, childId = null, type = 'functional') {
        const category = this.getCategoryByType(type);
        let output = {};
        category.map((item) => {
            if (item.id === catId)
                output = item;
        });

        let childCategory = output.children;
        if (childId && childCategory && childCategory.length) {
            childCategory.map((item) => {
                if (item.id === childId)
                    output = item;
            });
        }
        return output;
    }

    selectedCategoryType(categoryId, hits) {
        let output = {};
        if (!hits) return;
        hits.map((item) => {
            if (item.id === categoryId) {
                output = item;
            }
        });
        return output.name;
    }

    clearAllFilterAction(limit = 100, silentRedirect = true) {
        this.props.jobFilterInputChange({ props: 'search', value: '', searchNow: false });
        this.props.jobFilterInputChange({ props: 'category', value: '', searchNow: false });
        this.props.jobFilterInputChange({ props: 'experience', value: '', searchNow: false });
        this.props.jobFilterInputChange({ props: 'posted_on', value: '', searchNow: false });
        this.props.jobFilterInputChange({ props: 'sub_category', value: '', searchNow: false });
        this.props.jobFilterInputChange({ props: 'industry_category', value: '', searchNow: false });
        this.props.jobFilterInputChange({ props: 'availability', value: '', searchNow: false });
        this.props.jobFilterInputChange({ props: 'address', value: '', searchNow: true, limit });
        //This is done to clear any category slug from the url if there's any.
        if (silentRedirect)
            Router.push('/vacancies/[[...slug]]', '/vacancies/', { shallow: true });
    }

    clearFilter() {
        const { filter, selectedHits } = this.props.job;
        let showClearAll = 0;
        Object.keys(filter).map(function (type) {
            if (filter[type]) {
                showClearAll++;
            }
        });

        return (
            <div className="filter_se">
                {filter.search.length ? <Tag closable onClose={() => {
                    this.props.jobFilterInputChange({ props: 'search', value: '' });
                    this.setState({ search: '' })
                }}>{ucFirst(filter.search)}</Tag> : ''}

                {filter.address ? <Tag closable onClose={() => {
                    this.props.jobFilterInputChange({ props: 'address', value: '' })
                }}>{ucFirst(filter.address)}</Tag> : ''}

                {filter.sub_category ? <Tag closable onClose={() => {
                    Router.push('/vacancies/[[...slug]]', '/vacancies/', { shallow: true });
                    this.props.jobFilterInputChange({ props: 'sub_category', value: '' })
                }}>{this.selectedCategoryType(filter.sub_category, selectedHits)}</Tag> : ''}


                {filter.industry_category ? <Tag closable onClose={() => {
                    this.props.jobFilterInputChange({ props: 'industry_category', value: '' })
                }}>{this.whichCategory(filter.industry_category, null, 'industrial').name}</Tag> : ''}

                {filter.experience ? <Tag closable onClose={() => {
                    this.props.jobFilterInputChange({ props: 'experience', value: '' })
                }}>{jobExperienceType(filter.experience)}</Tag> : ''}

                {filter.posted_on ? <Tag closable onClose={() => {
                    this.props.jobFilterInputChange({ props: 'posted_on', value: '' })
                }}>{postedOnType(filter.posted_on)}</Tag> : ''}


                {filter.availability ? <Tag closable onClose={() => {
                    this.props.jobFilterInputChange({ props: 'availability', value: '' })
                }}>{availabilityType(filter.availability)}</Tag> : ''}

                {showClearAll >= 2 ? <Tag closable onClose={() => {
                    this.clearAllFilterAction();
                }}>Clear All</Tag> : ''}
            </div>);
    }

    renderSubCategory() {
        const { job, jobInputChange } = this.props;
        const category = this.getCategoryByType();
        const { filter } = job;
        let childCategory = [];

        category.map(function (item) {
            if (filter.category === item.id) {
                childCategory = item.children;
            }
        });


        if (childCategory.length > 0) {
            return (<SelectCategory selected={filter.sub_category}
                placeholder={'Being Specific, helpful for your job search accuracy..'}
                data={childCategory}
                onSelect={(value) => {
                    this.props.jobFilterInputChange({ props: 'sub_category', value });
                    this.props.generateStateUpdate(APP_GENERAL_STATE, {
                        props: 'showJobFilter',
                        value: false
                    });
                }} />)
        }
        return null;
    }


    render() {
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px'
        };

        const { job, filterCategory } = this.props;
        const categoryIndustry = this.getCategoryByType('industrial');
        const { filter, fetchingJobList, data } = job;
        return (<div>
            <div className="tr-breadcrumb bg-image section-before jobs-listing">
                <div className="container">
                    <div className="breadcrumb-info text-center">
                        <h2>Vacancies</h2>
                        <p>Rojgari sanjal offers the widest range of jobs available in Nepal. Search your field of
                            interest
                            and who knows the job of your dreams might be just a click away!</p>
                    </div>
                </div>
            </div>

            <div className="job-list-container">
                <div className="container-fluid">
                    <div className="job-item-list">
                        <div className="row">

                            <div className="col-lg-3 d-lg-block d-md-none hidden-sm">
                                {/*<Affix offsetBottom={-500}>*/}
                                <StickyBox offsetTop={100} offsetBottom={40}>

                                    <div ref={this.myRef} className={'sidebar-filter-web'}>
                                        <div className="filter_box filter_categories">
                                            <h3>Search by title</h3>
                                            <Search
                                                value={job.filter.search}
                                                onChange={(e) => {
                                                    this.props.jobFilterInputChange({
                                                        props: 'search',
                                                        value: e.target.value,
                                                        searchNow: false
                                                    });
                                                }}
                                                placeholder="Input search text"
                                                onSearch={value => {
                                                    this.props.jobFilterInputChange({ props: 'search', value });
                                                }} />
                                        </div>
                                        <div className="filter_box filter_categories">
                                            <h3>Search by address</h3>
                                            <Search
                                                value={job.filter.address}
                                                onChange={(e) => {
                                                    this.props.jobFilterInputChange({
                                                        props: 'address',
                                                        value: e.target.value,
                                                        searchNow: false
                                                    });
                                                }}
                                                placeholder="Input address"
                                                onSearch={value => {
                                                    this.props.jobFilterInputChange({ props: 'address', value });
                                                }} />
                                        </div>
                                        <div className="filter_box filter_categories">
                                            <h3>Job Function</h3>
                                            <InstantSearch
                                                searchClient={searchClient} indexName="dev_ROJAL">
                                                <SearchCategoryAlgo
                                                    previousSelectedCategory={filterCategory ? [filterCategory] : []}
                                                    mode={'default'}
                                                    selectedCategory={job.filter.sub_category}
                                                    onSelectCategory={(value, hits) => {
                                                        this.props.jobFilterInputChange({
                                                            props: 'sub_category',
                                                            value,
                                                            hits
                                                        });
                                                        this.props.generateStateUpdate(APP_GENERAL_STATE, {
                                                            props: 'showJobFilter',
                                                            value: false
                                                        });
                                                    }} />
                                            </InstantSearch>

                                            <br />
                                            <br />
                                        </div>
                                        <div className="filter_box filter_categories">
                                            <h3>Job By Industry</h3>
                                            <SelectCategory data={categoryIndustry} onSelect={(value) => {
                                                this.props.jobFilterInputChange({
                                                    props: 'industry_category',
                                                    value: '',
                                                    searchNow: false
                                                });
                                                this.props.jobFilterInputChange({ props: 'industry_category', value });
                                            }} selected={filter.industry_category} />
                                        </div>

                                        <div className="filter_box filter_categories">
                                            <h3>Job Type</h3>
                                            <Select style={{ width: '100%' }} value={filter.availability}
                                                defaultValue={filter.availability}
                                                onChange={(value) => {
                                                    this.props.jobFilterInputChange({ props: 'availability', value });
                                                }}>
                                                {Object.keys(availabilityType()).map(function (item, index) {
                                                    return <Option key={index}
                                                        value={item}>
                                                        {availabilityType(item)}
                                                    </Option>
                                                })}
                                            </Select>
                                        </div>

                                        <div className="filter_box filter_experience">
                                            <h3>Experience</h3>
                                            <Radio.Group onChange={(e) => {
                                                this.props.jobFilterInputChange({
                                                    props: 'experience',
                                                    value: e.target.value
                                                })
                                            }} value={filter.experience}>
                                                <Radio key={200} style={radioStyle} value={''}>
                                                    Any
                                                </Radio>
                                                {Object.keys(jobExperienceType()).map(function (item, i) {
                                                    return (<Radio key={i} style={radioStyle} value={item}>
                                                        {jobExperienceType(item)}
                                                    </Radio>
                                                    );
                                                })}
                                            </Radio.Group>
                                        </div>
                                        <div className="filter_box filter_experience">
                                            <h3>Posted Date</h3>
                                            <Radio.Group onChange={(e) => {
                                                this.props.jobFilterInputChange({ props: 'posted_on', value: e.target.value })
                                            }} value={filter.posted_on}>
                                                <Radio key={200} style={radioStyle} value={''}>
                                                    All
                                                </Radio>
                                                {Object.keys(postedOnType()).map(function (item, i) {
                                                    return (<Radio key={i} style={radioStyle} value={item}>
                                                        {postedOnType(item)}
                                                    </Radio>
                                                    );
                                                })}
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </StickyBox>

                            </div>

                            <div className="col-md-12 col-lg-9" ref={this.myRefJobList}>
                                <div className="filters-selected">
                                    {this.clearFilter()}
                                </div>
                                <div className="job_list_view_container">
                                    <Spin spinning={fetchingJobList} tip="Searching... Please wait.">
                                        <div className="job_list_view">
                                            <JobList ica={this.props.user.data.ica} applyJob={this.props.applyModalOpen}
                                                data={data} />
                                        </div>
                                    </Spin>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Drawer
                id={'drawer_custom'}
                className={'category_drawer drawer_custom'}
                title="Filter Jobs"
                placement="right"
                closable={false}
                onClose={() => {
                    this.props.generateStateUpdate(APP_GENERAL_STATE, { props: 'showJobFilter', value: false });
                }}
                visible={this.props.app.showJobFilter}>
                <div className="job-item-list">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="filter_box filter_categories">
                                <h3>Search by title</h3>
                                <Search
                                    value={job.filter.search}
                                    onChange={(e) => {
                                        this.props.jobFilterInputChange({
                                            props: 'search',
                                            value: e.target.value,
                                            searchNow: false
                                        });

                                    }}
                                    placeholder="Input search text"
                                    onSearch={value => {
                                        this.props.jobFilterInputChange({ props: 'search', value });
                                        this.props.generateStateUpdate(APP_GENERAL_STATE, {
                                            props: 'showJobFilter',
                                            value: false
                                        });
                                    }} />
                            </div>
                            <br />
                            <div className="filter_box filter_categories">
                                <h3>Search by address</h3>
                                <Search
                                    value={job.filter.address}
                                    onChange={(e) => {
                                        this.props.jobFilterInputChange({
                                            props: 'address',
                                            value: e.target.value,
                                            searchNow: false
                                        });

                                    }}
                                    placeholder="Input address"
                                    onSearch={value => {
                                        this.props.jobFilterInputChange({ props: 'address', value });
                                        this.props.generateStateUpdate(APP_GENERAL_STATE, {
                                            props: 'showJobFilter',
                                            value: false
                                        });
                                    }} />
                            </div>
                            <br />
                            <div className="filter_box filter_categories">
                                <h3>Job Function</h3>

                                <InstantSearch searchClient={searchClient} indexName="dev_ROJAL">
                                    <SearchCategoryAlgo
                                        mode={'default'}
                                        previousSelectedCategory={job.selectedHits}
                                        selectedCategory={filter.sub_category}
                                        onSelectCategory={(value, hits) => {
                                            this.props.jobFilterInputChange({
                                                props: 'sub_category',
                                                value,
                                                hits
                                            });
                                            this.props.generateStateUpdate(APP_GENERAL_STATE, {
                                                props: 'showJobFilter',
                                                value: false
                                            });
                                        }} />
                                </InstantSearch>
                            </div>

                            <div style={{ marginTop: 15 }} className="filter_box filter_categories">
                                <h3>Job By Industry</h3>
                                <SelectCategory data={categoryIndustry} onSelect={(value) => {
                                    this.props.jobFilterInputChange({
                                        props: 'industry_category',
                                        value: '',
                                        searchNow: false
                                    });
                                    this.props.jobFilterInputChange({ props: 'industry_category', value });
                                }} selected={filter.industry_category} />
                            </div>

                            <br />

                            <div className="filter_box filter_categories">
                                <h3>Job By Industry</h3>
                                <SelectCategory data={categoryIndustry} onSelect={(value) => {
                                    this.props.jobFilterInputChange({
                                        props: 'industry_category',
                                        value: '',
                                        searchNow: false
                                    });
                                    this.props.jobFilterInputChange({ props: 'industry_category', value });
                                }} selected={filter.industry_category} />
                            </div>

                            <div className="filter_box filter_experience">
                                <h3>Experience</h3>
                                <Radio.Group onChange={(e) => {
                                    this.props.jobFilterInputChange({ props: 'experience', value: e.target.value });
                                    this.props.generateStateUpdate(APP_GENERAL_STATE, {
                                        props: 'showJobFilter',
                                        value: false
                                    });
                                }} value={filter.experience}>
                                    <Radio key={200} style={radioStyle} value={''}>
                                        Any
                                    </Radio>
                                    {Object.keys(jobExperienceType()).map(function (item, i) {
                                        return (<Radio key={i} style={radioStyle} value={item}>
                                            {jobExperienceType(item)}
                                        </Radio>
                                        );
                                    })}
                                </Radio.Group>
                            </div>
                            <br />

                            <div className="filter_box filter_experience">
                                <h3>Date Posted</h3>
                                <Radio.Group onChange={(e) => {
                                    this.props.jobFilterInputChange({ props: 'posted_on', value: e.target.value });
                                    this.props.generateStateUpdate(APP_GENERAL_STATE, {
                                        props: 'showJobFilter',
                                        value: false
                                    });
                                }} value={filter.posted_on}>
                                    <Radio key={200} style={radioStyle} value={''}>
                                        All
                                    </Radio>
                                    {Object.keys(postedOnType()).map(function (item, i) {
                                        return (<Radio key={i} style={radioStyle} value={item}>
                                            {postedOnType(item)}
                                        </Radio>
                                        );
                                    })}
                                </Radio.Group>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="nav-closer">
                    <a href="" onClick={(e) => {
                        e.preventDefault();
                        this.props.generateStateUpdate(APP_GENERAL_STATE, { props: 'showJobFilter', value: false });
                    }}><i className={'fa fa-times'} /></a>
                </div>
            </Drawer>

            <GetStarted isAuthenticated={this.props.user.authCheck} />

        </div>);
    }

    componentDidMount() {
        const html = document.querySelector('html');
        html.style.height = 'initial';
    }

    componentWillUnmount() {
        this.clearAllFilterAction(9, false);
    }
}

const mapStateToProps = (state) => {
    return {
        category: state.category,
        job: state.job,
        app: state.app,
        user: state.user
    }
};

export default connect(mapStateToProps, {
    jobFilterInputChange,
    getAllJobs,
    applyModalOpen,
    generateStateUpdate
})(Vacancies);